module.exports = __webpack_public_path__ + "static/media/metamask.e9ada72b.png";